"use client"
import { InputLabel, MenuItem, Select } from "@mui/material"
import { Controller } from "react-hook-form"
import { colors } from "ui"
import { StyledFormControl } from "./styles"
import { FindingSupplierSelectFieldProps } from "./types"

const FindingSupplierSelectField = ({
  field,
  control,
  error,
  isSubmitted,
}: FindingSupplierSelectFieldProps) => {
  if (!field || !field.preValues) return null

  const options = field.preValues || []

  return (
    <StyledFormControl variant="filled" error={!!error} size="medium">
      <InputLabel htmlFor={field.id}>{field.helpText}</InputLabel>
      <Controller
        name={field.id}
        control={control}
        render={({ field: { onChange, value } }) => (
          <Select
            id={field.id}
            value={value || ""}
            onChange={onChange}
            inputProps={{
              "aria-invalid": !!error,
              "aria-describedby": `${field.id}-helper-text`,
            }}
            MenuProps={{
              disablePortal: true,
              PaperProps: {
                sx: {
                  borderRadius: "12px",
                  border: `1px solid ${colors.lightGray}`,
                  boxShadow: "-4px 8px 30px 0px rgba(2, 1, 64, 0.12)",
                  maxHeight: "200px",
                  flexDirection: "column",
                },
              },
            }}
          >
            {options.map((option, index) => (
              <MenuItem
                key={`${index}-${option.value}`}
                value={option.value}
                sx={{
                  color: colors.black,
                  "&:hover": {
                    backgroundColor: colors.red,
                    color: colors.white,
                  },
                }}
              >
                {option.caption || option.value}
              </MenuItem>
            ))}
          </Select>
        )}
      />
      {isSubmitted && error && (
        <div
          id={`${field.id}-helper-text`}
          style={{
            color: colors.red,
            fontSize: "12px",
            marginTop: "4px",
            marginLeft: "14px",
          }}
        >
          {error?.message as string}
        </div>
      )}
    </StyledFormControl>
  )
}

export default FindingSupplierSelectField
